import { render, staticRenderFns } from "./BlockType109.vue?vue&type=template&id=e872bd86&scoped=true"
import script from "./BlockType109.vue?vue&type=script&lang=ts"
export * from "./BlockType109.vue?vue&type=script&lang=ts"
import style0 from "./BlockType109.vue?vue&type=style&index=0&id=e872bd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e872bd86",
  null
  
)

export default component.exports